import { SearchModuleService } from 'src/shared/search.module.service';
import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
//@ts-ignore
import { software_update, user_access, system_manager } from "../assets/conf_urls.json"
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from '../app/services/auth.service';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';

@Component({
  selector: 'app-software-upgrade',
  templateUrl: './software-upgrade.component.html',
  styleUrls: ['./software-upgrade.component.css']
})
export class SoftwareUpgradeComponent implements OnInit {
  //forms
  form_updatelist: FormGroup
  show_progressbar = false

  //
  switcher_toggle_navigator = true;
  show_job_form = false;
  // upgrade list
  upgrade_list = []
  final_upgrade_list = []
  //tmp
  package_list = []
  //for user access
  user_permission;
  user_email = localStorage.getItem('useremail');
  // for user access

  sort_tree_by = "folder"
  sort_by_list = [
    { value: 'folder', viewValue: 'Folder' },
    { value: 'software_name', viewValue: 'Software Name' },
    { value: 'software_version', viewValue: 'Software Version' },
    { value: 'product_id', viewValue: 'Product Id' }
  ];

  recieve_selected_items = [];

  recieve_selected_multiple_items(items: any) {
    this.recieve_selected_items = items
    items.forEach(item => {
      if (item["parent"]) {
        delete item["parent"]
      }
    });
  }

  move_selected_to_list() {

    this.show_progressbar = true
    let request_body = {
      "event": "select_by_id_list", "id_list": this.recieve_selected_items
    }
    this.http.post(system_manager.services, request_body).subscribe(response_data => {

      if (response_data["status_type"] == "Success") {
        //found system profile
        if (response_data["data"][0]) {
          response_data["data"].forEach(item => {
            this.move_single_system_to_list(item)
          });
          this.show_progressbar = false

        }
        //no data for this mac address
        else {
          //change the message only
          this.show_progressbar = false;
        }
      } else {
        this.show_progressbar = false;
      }
    }, err => {
      this.loggerService.log("SoftwareUpgradeComponent", err.message, Levels.error)

    })

    this.recieve_selected_items = []
  }

  move_single_system_to_list(system_obj) {
    if (this.upgrade_list.find(element => element.system.id == system_obj["id"])) {
      return
    }
    //  1. get the package
    let sw_name = ""
    sw_name = system_obj["software_name"]
    this.get_packages_by_sw_name(sw_name, system_obj)

    //  2. create the upgrade list item

  }

  selected_option_value = ""
  selected_option_sw_name = ""
  changed_selected_option(value, sw_name, button_id) {
    this.selected_option_value = value
    this.selected_option_sw_name = sw_name
    document.getElementById("value_" + button_id).hidden = false
  }

  change_all_similar(button_id) {
    if (this.selected_option_sw_name.length > 0 && this.selected_option_value.length > 0) {
      Object.keys(this.upgrade_list).forEach(item => {
        if (this.upgrade_list[item]['system']["software_name"] == this.selected_option_sw_name) {
          let temp = 'value_' + this.upgrade_list[item]['system']['id']
          this.form_updatelist.get(temp).setValue(this.selected_option_value);
        }

      })
      this.selected_option_value = ""
      this.selected_option_sw_name = ""
      document.getElementById(button_id).hidden = true
    }
  }

  reload_treeView() {

    setTimeout(() => {
      try {
        let element: HTMLElement = document.getElementsByClassName('nav-link')[0] as HTMLElement;
        let element1: HTMLElement = document.getElementsByClassName('nav-link')[1] as HTMLElement;
        element.click();
        element1.click();
      } catch (error) {

      }


    }, 700)
  }
  get_user_access_service(useremail: any) {
    useremail = useremail.trim();

    localStorage.setItem('useremail', useremail);
    var json_object = { 'user_email': useremail };
    this.http.post(user_access.url, json_object).subscribe(data => {

      if (data.toString().length > 0) {
        //if user active
        if (data[0]['is_active'] == 'y') {
          var useraccess = data[0]['user_permission'];
          localStorage.setItem('ua', useraccess);
          //create a session
          //end
          // window.location.href = '/home';
        }
        //if user not active
        if (data[0]['is_active'] == 'n') {
          window.location.href = '/newaccess';
        }
      }

    }, err => {
      this.loggerService.log("SoftwareUpgradeComponent", err.message, Levels.error)
    });
    //  end
  }

  constructor(private _snackBar: MatSnackBar,
    private http: HttpClient,
    private _formbuilder: FormBuilder,
    private authService: AuthService,
    private loggerService: LoggerService,
    private searchModuleService: SearchModuleService) {
  }

  ngOnInit(): void {
    this.searchModuleService.dataTransmitted.subscribe(data =>
      this.recieve_selected_multiple_items(data)
    )
    this.form_updatelist = this._formbuilder.group({
      start_at: ['', Validators.required],

    });
  }
  //1. get package.
  //2. add to form.
  get_packages_by_sw_name(sw_name: any, row: any) {
    let flag = 1
    this.package_list = []
    //let row = event["item"]["props"]
    //if (row == undefined) {
    //  row = event["item"]
    //}
    let json_object = { "event": "query_package_by_sw_name", "software_name": sw_name }
    this.http.post(software_update.services, json_object).subscribe(response_data => {
      if (response_data["status"] == "success") {
        this.package_list = response_data["data"][0]["packages"]

        let system_name = row["system_name"]

        Object.keys(this.upgrade_list).forEach(item => {
          let current_system_name = this.upgrade_list[item]["system_name"]

          if (current_system_name == system_name) {
            this.upgrade_list.splice(parseInt(item), 1)
          }

        })
        //add package with system

        this.upgrade_list.push({ "system": row, "package": this.package_list })

        //add to form


        let fc_id = row['id']

        const fc_value = new FormControl('')
        const fc_system = new FormControl(row['system_name'])
        const fc_ip = new FormControl(row['system_ip'])
        const fc_operation = new FormControl('Software Upgrade ' + row['system_name'] + '')
        const fc_status = new FormControl('new')
        const fc_isexecuted = new FormControl('0')
        this.form_updatelist.addControl('value_' + fc_id, fc_value)
        this.form_updatelist.addControl('system_name_' + fc_id, fc_system)
        this.form_updatelist.addControl('system_ip_' + fc_id, fc_ip)
        this.form_updatelist.addControl('operation_name_' + fc_id, fc_operation)
        this.form_updatelist.addControl('job_status_' + fc_id, fc_status)
        this.form_updatelist.addControl('is_executed_' + fc_id, fc_isexecuted)
        // this.form_updatelist.addControl('start_at' , fc_value)
      } else {

      }
    }, err => {
      this.loggerService.log("SoftwareUpgradeComponent", err.message, Levels.error)
    })
  }

  delete_item_from_array(item: any) {
    let current_id = item["id"]
    const iterate_index = this.upgrade_list.findIndex(i => i.system.id == item["id"]);
    this.upgrade_list.splice(iterate_index, 1)
    // Object.keys(this.upgrade_list).forEach(index => {
    //   let iterate_id = this.upgrade_list[index]["system"]["id"]
    //   if (current_id == iterate_id) {
    //     this.upgrade_list.splice(parseInt(index), 1)
    //   }
    // })
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  create_job() {
    let parent_job_id = this.uuidv4()
    let date = new Date()

    Object.keys(this.form_updatelist.value).forEach(key => {
      let job_id = this.uuidv4()
      if (key.includes('system_name_')) {
        let row_id = key.split('_')[2]
        let system_name = this.form_updatelist.value[key]
        let system_ip = this.form_updatelist.value["system_ip_" + row_id]
        let operation_name = this.form_updatelist.value["operation_name_" + row_id]
        let job_status = this.form_updatelist.value["job_status_" + row_id]
        let is_executed = this.form_updatelist.value["is_executed_" + row_id]
        let system_command = 'xCommand SystemUnit SoftwareUpgrade URL:"' + this.form_updatelist.value["value_" + row_id] + '"'
        let start_at = this.form_updatelist.get('start_at').value

        if (system_command !== undefined && system_command.length !== 0 && system_command !== null) {

          let jobj = {
            "event": "create_job_sw_upgrade",
            "system_name": system_name,
            "system_ip": system_ip,
            "operation_name": operation_name,
            "job_status": job_status,
            "is_executed": is_executed,
            "system_command": system_command,
            "start_at": start_at,
            "parent_job_id": parent_job_id,
            "job_id": job_id
          }
          //post command to the template
          this.show_progressbar = true
          this.http.post(software_update.services, jobj).subscribe(response_data => {

            if (response_data["status"] == "success") {
              this.show_progressbar = false
              this.openSnackBar(response_data["message"], response_data["status"])
            } else {
              this.show_progressbar = false
              this.openSnackBar(response_data["message"], response_data["status"])

            }
          }, err => {
            this.loggerService.log("SoftwareUpgradeComponent", err.message, Levels.error)
          })
        } else {

        }
      }

    })
  }






}
